<template lang="pug">
  .component-account-status
    .status(v-for="status in statuses")
      .stats
        i.fa.fa-2x(:class="getStatusClass(status)", @click="$emit('input', status)")
        p.no-wrap {{status.replace(/_status|_method/gi,'')}}
</template>

<script>
  export default {
    name: 'AccountStatus',
    methods: {
      getStatusClass(status) {
        switch (status) {
          case 'document_status': {
            let currentStatus = this.accountStatus.document_status
            return `fa-id-card ${currentStatus}`
          }
          case 'payment_method': {
            let currentStatus = this.accountStatus.payment_method ? 'valid' : ''
            return `fa-credit-card ${currentStatus}`
          }
          case 'subscription': {
            let currentStatus = this.accountStatus.subscription ? 'valid' : ''
            return `fa-money ${currentStatus}`
          }
          case 'address': {
            let currentStatus = this.accountStatus.address ? 'valid' : ''
            return `fa-address-card ${currentStatus}`
          }
          case 'client': {
            let currentStatus = this.accountStatus.client ? 'valid' : 'pending_validation'
            return `fa-user ${currentStatus}`
          }
          case 'driver': {
            let currentStatus = this.accountStatus.driver ? 'valid' : 'pending_validation'
            return `fa-user ${currentStatus}`
          }

        }
      }
    },
    props: {
      toggleable: {
        type: Boolean,
        default: false
      },
      accountStatus: {
        type: Object
      },
      statuses: {
        type: Array,
        default: () => {
          // client, driver
          return ['document_status', 'payment_method', 'subscription', 'address']
        }
      }
    }
  }
</script>

<style lang="sass">
  .component-account-status
    display: flex
    flex-direction: row
    justify-content: space-around

    .status
      margin: 0 1em
      text-align: center

      .valid
        color: #64db6f

      .pending_validation
        color: #ffdc66

</style>



// WEBPACK FOOTER //
// AccountStatus.vue?6f62aeec